
































































import Vue from "vue";
import { isEmail } from "validator";
import { IState, IKeyword, ApplicationType } from "../store/state";

import KeywordList from "./KeywordList.vue";
import { subscribe } from "../store/actions";

interface SubscribeFormData {
  email: {
    value: string;
    valid: boolean;
    dirty: boolean;
  };
  toc: {
    value: boolean;
    valid: boolean;
    dirty: boolean;
    focused: boolean;
  };
  keywords: {
    value: string[];
    valid: boolean;
  };
  isUpdate: boolean;
}

interface SubscribeFormComputed {
  postUrl: string;
  tocString: string;
  loading: boolean;
  gdpr: string;
  unsubscribeUrl: string;
  tocFocusedClass: any;
  type: ApplicationType;
}

interface SubscribeFormMethods {
  subscribe(): void;
  unsubscribe(): void;
}

export default Vue.extend<
  SubscribeFormData,
  SubscribeFormMethods,
  SubscribeFormComputed,
  {}
>({
  name: "SubscribeForm",
  data() {
    return {
      email: {
        value: "",
        valid: true,
        dirty: false
      },
      toc: {
        value: false,
        valid: true,
        dirty: false,
        focused: false
      },
      keywords: {
        value: this.$store.getters.selectedKeywords,
        valid: true
      },
      isUpdate: false
    };
  },
  watch: {
    email: {
      handler(email) {
        if (!email.dirty) {
          this.email.dirty = true;
        }
      },
      deep: true
    },
    toc: {
      handler(toc) {
        if (!toc.dirty) {
          this.toc.dirty = true;
        }
      },
      deep: true
    }
  },
  created() {
    const email = (this.$store.state as IState).config.email;
    if (email) {
      this.email.value = email;
      this.isUpdate = true;
    }
  },
  computed: {
    tocFocusedClass() {
      return {
        "sh-form__checkbox-focused": this.toc.focused
      };
    },
    postUrl() {
      return (this.$store.state as IState).config.subscribeUrl;
    },
    tocString() {
      return (this.$store.state as IState).config.toc;
    },
    loading() {
      return (this.$store.state as IState).status.loading;
    },
    gdpr() {
      return (this.$store.state as IState).config.gdpr;
    },
    unsubscribeUrl() {
      return (this.$store.state as IState).config.unsubscribe.unsubscribeUrl;
    },
    type() {
      return (this.$store.state as IState).config.type;
    }
  },
  methods: {
    unsubscribe() {
      this.email.valid = isEmail(this.email.value);
      if (this.email.valid) {
        // this.$store.dispatch(subscribe({
        // 	email: this.email.value,
        // 	keywords: []
        // }))
        window.location.href = (this.$store
          .state as IState).config.unsubscribe.unsubscribeUrl;
      }
    },
    subscribe() {
      this.email.valid = isEmail(this.email.value);
      this.toc.valid = this.toc.value;
      this.keywords.valid = this.keywords.value.length > 0;

      const isValid =
        this.email.valid &&
        this.toc.valid &&
        ((this.type === "news" && this.keywords.valid) || true);

      if (isValid) {
        this.$store.dispatch(
          subscribe({
            email: this.email.value,
            keywords: this.keywords.value
          })
        );
      }
    }
  },
  components: {
    KeywordList
  }
});
